import script from "./ProfileProjectsAsPerformerItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileProjectsAsPerformerItem.vue?vue&type=script&setup=true&lang=js"

import "./ProfileProjectsAsPerformerItem.vue?vue&type=style&index=0&id=fc36c88c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc36c88c"]])

export default __exports__